import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { MACRO_FIELDS } from "./macro-fields"

export const getMacros = api(async function getMacros({ macroIds, retrieveDeleted } = {}) {
    return query(
        gql`
            query GetMacros($macroIds: [String!], $retrieveDeleted: Boolean) {
                getMacros(macroIds: $macroIds, retrieveDeleted: $retrieveDeleted) {
                    ${MACRO_FIELDS}
                }
            }
        `,
        { macroIds, retrieveDeleted },
        { returns: "getMacros" }
    )
})
